export default {"src":"/_next/static/media/CTLT.7f2f7095.svg","height":18,"width":18};